import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { PromptsService } from "../../services/Prompts.services";
import { PromptForm, PromptVersion } from "../../models/PromptForm.model";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";

@Component({
  name: "Prompts",
  components: { DynamicSelect }
})
export default class SavePrompt extends Vue {
  @Prop({ default: false }) promptId!: string;
  @Prop({ default: [] }) itemList!: PromptForm[];

  @Inject() promptsService!: PromptsService;

  SAVE_BTN = "Guardar";
  CANCEL_BTN = "Cancelar";
  PROMPT_STATE = "Estado del prompt";
  PROMPT_NAME = "Nombre del prompt";
  PROMPT_TEXT = "Texto del prompt";
  cardClass = STYLE_CLASSES.CARD;
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  promptForm = false;
  showForm = true;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  switchClass = STYLE_CLASSES.SWITCH;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  versionsData = [] as DynamicSelectData[];
  versionsOptionsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "Seleccionar version",
    hideDetails: false,
    attach: false,
    limit: 3,
    required: false
  };
  promptFormData: PromptForm = {
    name: "",
    prompt: "",
    state: true,
    versions: []
  };

  mounted() {
    console.log("SavePrompt mounted");
    if (this.promptId) {
      this.changePrompt();
    }
  }

  @Watch("promptForm")
  checkPromptForm() {
    console.log("promptForm changed:", this.promptForm);
  }

  @Watch("promptId")
  changePrompt() {
    const prompt = this.itemList.find(
      (item: PromptForm) => item.id === this.promptId
    );
    if (prompt) {
      this.promptFormData.id = prompt.id;
      this.promptFormData.name = prompt.name;
      this.promptFormData.prompt = prompt.prompt;
      this.promptFormData.state = prompt.state === "Activo" ? true : false;
      this.promptFormData.versions = prompt.versions;
      this.versionsOptionsConfig.listAll = (prompt.versions.map(v => {
        return {
          id: v.id,
          name: new Date(v.dateCreated).toLocaleString()
        };
      }) as unknown) as DynamicSelectData[];
    }
  }

  async savePrompt() {
    try {
      console.log("Guardando prompt:", this.promptFormData);
      this.promptFormData.state = this.promptFormData.state
        ? "Activo"
        : "Inactivo";
      const promptSaved = await this.promptsService.savePrompt(
        this.promptFormData
      );

      if (promptSaved.code === Http.Created) {
        Snackbar.popSuccess("Prompt guardado exitosamente");
        this.$emit("promptSaved");
        return;
      }

      Snackbar.popError(promptSaved.message);
    } catch (error) {
      console.error("Error al guardar el prompt:", error);
    }
  }

  onVersionChange() {
    console.log("item", this.versionsData[0]);
    console.log("versions", this.promptFormData.versions);
    const version = this.promptFormData.versions.find(
      (v: PromptVersion) => v.id === this.versionsData[0].id
    );
    console.log("version", version);
    if (version) {
      this.promptFormData.name = version.name;
      this.promptFormData.prompt = version.prompt;
    }
  }
}
